module.exports = __webpack_public_path__ + "static/media/bmp.aaa7cab1.png";